import axios from 'axios';
import formData from '../shared/formData';

let wrapEl = document.querySelector('.auth-register__confirm');
let inputEl = wrapEl.querySelector('input');
let buttonEl = wrapEl.querySelector('button');

buttonEl.onclick = () => {
  axios({
    url: ajaxurl,
    method: 'post',
    data: formData({
      action: 'auth_confirm',
      code: inputEl.value
    })
  }).then((response) => {
    if(response.data == 'success') {
      alertify.success('Пользователь успешно зарегистрирован');
      location.href = '/account';
    }
    else if(response.data == 'create fail') alertify.error('При создании пользователя произошла ошибка');
    else if(response.data == 'fail') alertify.error('Код не совпадает с тем, что был отправлен на email');
    else alertify.error('Непредвиденная ошибка');
  });
};